<template>
  <div class="col-12 mt-3">
    <AppLoading :loading="carregando" />
    <AppFormCabecalho titulo="Dispositivos" icon="mdi mdi-server">
      <div slot="actions">
        <b-button
          @click="getDispositivos()"
          variant="outline-secondary"
          size="sm"
          class="mr-2"
        >
          <i class="mdi mdi-refresh"></i> Atualizar
        </b-button>
        <b-button
          :disabled="erroAoCarregarDispositivos"
          @click="abrirModal()"
          variant="outline-secondary"
          size="sm"
        >
          <i class="mdi mdi-plus-circle"></i> Adicionar Dispositivo
        </b-button>
      </div>
    </AppFormCabecalho>
    <div class="table-responsive">
      <table class="table table-sm table-striped table-bordered">
        <thead>
          <tr>
            <th>AET</th>
            <th>Endere&ccedil;o</th>
            <th>Porta</th>
            <th class="text-center">Retrieve sem compressão</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="semDispositivos">
            <td colspan="5">Nenhum dispositivo cadastrado</td>
          </tr>
          <tr v-if="erroAoCarregarDispositivos">
            <td colspan="5" class="text-danger">
              <i class="mdi mdi-alert-outline"></i> Ocorreu um erro ao carregar
              Dispositivos!
            </td>
          </tr>
          <tr v-for="(dispositivo, idx) in dispositivos" :key="idx">
            <td>{{ dispositivo.aet }}</td>
            <td>{{ dispositivo.endereco }}</td>
            <td>{{ dispositivo.porta }}</td>
            <td class="text-center">
              {{ dispositivo.retrieveSemCompressao | retrieveText }}
            </td>
            <td class="text-center">
              <b-button
                @click="echo(dispositivo)"
                size="sm"
                variant="link"
                title="Echo"
              >
                <i class="mdi mdi-lan-connect"></i>
              </b-button>
              <b-button
                @click="editar(dispositivo)"
                size="sm"
                variant="link"
                title="Editar"
              >
                <i class="mdi mdi-pencil"></i>
              </b-button>
              <b-button
                size="sm"
                variant="link"
                title="Remover"
                @click="remover(dispositivo)"
              >
                <i class="mdi mdi-delete text-danger"></i>
              </b-button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <DispositivoModal
      v-model="modal"
      :dispositivo="dispositivo"
      v-on:salvar="salvar"
    />
  </div>
</template>
<script>
import ServidorApi from "../../api/servidorApi";
import dispositivoFactory from "../../utils/dispositivoFactory";

import AppLoading from "../util/AppLoading.vue";
import AppFormCabecalho from "../layout/AppFormCabecalho.vue";
import DispositivoModal from "./DispositivoModal.vue";

const dispositivoData = dispositivoFactory();

export default {
  components: { AppFormCabecalho, AppLoading, DispositivoModal },
  computed: {
    semDispositivos() {
      return !this.erroCarregar && this.dispositivos.length <= 0;
    },
    erroAoCarregarDispositivos() {
      return this.erroCarregar && this.dispositivos.length <= 0;
    }
  },
  data() {
    return {
      carregando: false,
      erroCarregar: false,
      modal: false,
      dispositivo: dispositivoData,
      dispositivos: []
    };
  },
  methods: {
    abrirModal(dispositivo = dispositivoFactory()) {
      this.modal = true;
      this.dispositivo = dispositivo;
    },
    salvar(dispositivo) {
      if (dispositivo.idx >= 0) {
        this.dispositivos.splice(dispositivo.idx, 1, dispositivo);
      } else {
        this.dispositivos.push(dispositivo);
      }
    },
    editar(dispositivo) {
      this.dispositivo = Object.assign({}, dispositivo);
      const idx = this.dispositivos.indexOf(dispositivo);
      Object.assign(this.dispositivo, { idx });
      this.abrirModal(this.dispositivo);
    },
    remover(dispositivo) {
      this.carregando = true;
      ServidorApi.removerDispositivo(dispositivo.id)
        .then(() => {
          this.carregando = false;
          const idx = this.dispositivos.indexOf(dispositivo);
          this.dispositivos.splice(idx, 1);
        })
        .catch(e => {
          console.log(e);
          this.carregando = false;
        });
    },
    getDispositivos() {
      this.carregando = true;
      ServidorApi.dispositivos()
        .then(resp => {
          this.dispositivos = resp;
          this.carregando = false;
          this.erroCarregar = false;
        })
        .catch(e => {
          console.log(e);
          this.carregando = false;
          this.erroCarregar = true;
        });
    },
    echo({ id }) {
      ServidorApi.echoDispositivo(id)
        .then(() => {})
        .catch(e => {
          console.log(e);
        });
    }
  },
  created() {
    this.getDispositivos();
  },
  filters: {
    retrieveText: function(value) {
      return value ? "Sim" : "Não";
    }
  }
};
</script>
